<template>
  <div>
    <div data-cy="form-label" class="b-dialog__top-panel mb-5">
      <h2>{{$t('CONTENT.contract.contract_editing')}}</h2>
      <button class="b-btn b-btn_border_none" @click="closeContractEditingDialog">
        <dynamic-icon icon="close" />
      </button>
    </div>
    <form class="b-form b-dialog__form">
      <server-error :error="error" />
      <div v-for="(item, index) in currentPeriodSpendings" :key="index">
        <PeriodSpendingsItem
          :periodSpendingsItem="item"
          :periodSpendingsItemIndex="index"
          :periodSpendingsLength="currentPeriodSpendings.length"
          :systemCurrencyCode="settingsCurrencyCode"
          @onDeletePeriodSpending="deletePeriodSpendingsItem"
        ></PeriodSpendingsItem>
      </div>
      <div class="row mt-4">
        <div class="col-5">
          <div class="b-form__container">
            <button
              type="button"
              class="b-btn"
              @click="addPeriodSpendings"
              :disabled="isDisabledAddPeriodSpendings"
            >
              <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
              {{$t('CONTENT.contract.add_period')}}
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-6 offset-6">
          <div
            class="b-form__container b-form__container_type_flex b-form__container_type_flex_end"
          >
            <button
              data-cy="save-button"
              class="b-btn b-btn_type_primary"
              type="submit"
              :disabled="isDisabledAddPeriodSpendings"
              @click="onSubmit"
            >{{$t('CONTENT.save')}}</button>
            <button
              class="b-btn b-btn_type_empty m-2"
              @click="closeContractEditingDialog"
            >{{$t('CONTENT.cancel')}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import PeriodSpendingsItem from "../../PeriodSpendingsItem";
  import PeriodSpendings from "../../../../../models/alternativeContract/PeriodSpendings";

  export default {
    components: {
      PeriodSpendingsItem,
    },
    props: {
      periodSpendings: {
        type: Array
      },
    },
    data() {
      return {
        error: null,
        currentPeriodSpendings: []
      };
    },
    created() {
      this.updateFormData();
    },
    watch: {
      periodSpendings: {
        immediate: true,
        handler() {
          this.updateFormData();
        }
      },
    },
    computed: {
      ...mapGetters (["getContractSettings"]),
      settingsCurrencyCode() {
        return this.getContractSettings.currencyCode;
      },
      isDisabledAddPeriodSpendings() {
        for (let i = 0; i < this.currentPeriodSpendings.length; i++) {
          if (
            this.currentPeriodSpendings[i].startDate === null ||
            this.currentPeriodSpendings[i].endDate === null ||
            this.currentPeriodSpendings[i].sum === null
          ) {
            return true;
          }
        }

        return false;
      },
    },
    methods: {
      updateFormData() {
        if (this.periodSpendings.length !== 0) {
          this.currentPeriodSpendings = _.cloneDeep(this.periodSpendings);
        }
      },
      addPeriodSpendings() {
        this.currentPeriodSpendings.push(PeriodSpendings.createNew());
      },
      deletePeriodSpendingsItem(itemIndex) {
        this.currentPeriodSpendings.splice (itemIndex, 1);
      },
      closeContractEditingDialog() {
        this.$emit("close");
        this.currentPeriodSpendings = _.cloneDeep(this.periodSpendings);
      },
      onSubmit(e) {
        e.preventDefault();
        this.$emit('onSaveEditing', this.currentPeriodSpendings);
        this.$emit("close");
        this.currentPeriodSpendings = _.cloneDeep(this.periodSpendings);
      }
    }
  };
</script>
